export default __webpack_public_path__ + "static/media/sauced_pizza.403ecf99.jpg";